import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CreateSLAResponseDto,
  UpdateSLARequestDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

type UseUpdateSLAOptions = {
  onError?: (error: ExtendedAxiosError) => void;
  onSuccess?: (data: CreateSLAResponseDto) => void;
};

export function useUpdateSLA(options: UseUpdateSLAOptions) {
  const { onError, onSuccess } = options;
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    CreateSLAResponseDto,
    ExtendedAxiosError,
    UpdateSLARequestDto & { id: CreateSLAResponseDto['id'] }
  >({
    mutationKey: ['sla'],
    mutationFn: ({ id, ...sla }) =>
      api.slasApi.updateSLA(id, sla).then((r) => r.data),
    onError,
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: ['slas'],
      });
      onSuccess?.(data);
    },
  });
}
